import { cn } from '../utils/cn'

export default function Container({ children, className = '' }) {
  return (
    <div className={cn('container mx-auto px-6 lg:max-w-[1129px]', className)}>
      {children}
    </div>
  )
}
